const rawBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

const backendBaseUrl =
  rawBackendUrl && rawBackendUrl !== "undefined"
    ? rawBackendUrl.replace(/\/+$/, "")
    : "http://localhost:8000";

export const API = `${backendBaseUrl}/api`;
